import { useCallback } from "react";

const usePrintInvoice = (logo) => {
  const handlePrintInvoice = useCallback(
    (invoice) => {
      const printWindow = window.open("", "_blank");
      console.log(invoice);
      const invoiceCategories = invoice.invoiceCategories || [];
      const categoryRows = invoiceCategories.length
        ? invoiceCategories
            .map(
              (category) => `
              <tr>
                <td>${category.category?.name || "لا يوجد"}</td>
                <td>${category?.quantity || 0}</td>
                <td>${category?.price || 0}</td>
                <td>${category?.total || 0}</td>
              </tr>
            `
            )
            .join("")
        : `<tr><td colspan="4" style="text-align: center;">لا توجد فئات</td></tr>`;

      const formattedDate =
        new Date(invoice.invoiceDate).toLocaleDateString("ar-EG") || "N/A";

      printWindow.document.write(`
      <html>
        <head>
          <title>فواتير</title>
      <style>
/* General Body Styles */
body {
  font-family: "Arial", sans-serif;
  margin: 0;
  padding: 0;
  direction: rtl;
  color: #333;
  // background-color: #f9f9f9;
  // display: flex;
  // justify-content: center;
  // align-items: flex-start;
  font-weight: bold;
  min-height: 100vh;
}

/* Ensure Proper Print Setup */
@page { 

  size: A4 portrait;

  }

/* Invoice Wrapper - Tiny Half A4 */
.page-break {
  width: 90mm; /* Half of A4 */
  // margin: 5px auto;
  padding: 5px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  page-break-after: always; /* Ensure each invoice prints separately */
  break-inside: avoid;
}

/* Fix Blank Page Issue - No extra page breaks */
.page-break:first-child {
  page-break-before: auto !important;
}

/* Invoice Header */
.invoice-header h2 {
  margin: 0;
  text-align: center;
  color: #2c3e50;
  font-size: 12px;
}

/* Compact Layout */
.row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 5px;
  margin-bottom: 3px;
}

/* Client Info */
.client-info {
  flex: 1;
  border-radius: 4px;
  padding: 3px;
  color: black;
  font-size: 8px;
  font-weight: 500;
}

.client-info p {
  margin: 1px 0;
}

/* Invoice Table */
table {
  width: 100%;
  border-collapse: collapse;
  margin: 3px 0;
  font-size: 8px;
  background: #fff;
}

th, td {
  border: 1px solid black !important;
  padding: 2px;
  font-size: 8px;
  font-weight: 500;
  text-align: center;
}

th {
  color: black;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* Summary Table */
.summary-table {
  margin-top: 3px;
  text-align: left;
}

.summary-table td {
  padding: 2px;
}

/* Ensure Invoice Stays in Half A4 */
.container {
  text-align: center;
  max-width: 150mm;
  // margin: 0 auto;
  padding: 5px;
  background-color: #fff;
  border-radius: 8px;
}

/* Print Styles */
@media print {
  body {
    background-color: #fff !important;
    padding: 0;
    margin: 0;
    font-weight: bold;
  }

  .container {
    box-shadow: none !important;
    margin: 0;
    padding: 0;
    max-width: 100%;
  }

  .page-break {
    page-break-before: avoid; /* Prevents extra blank pages */
  }

  table {
    font-size: 7px;
  }

  th, td {
    padding: 2px;
  }
}
.print-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  direction: rtl;
  margin-bottom: 6px;
  padding-bottom: 5px;
  border-bottom: 1px solid #000;
}

.print-logo {
  width: 55px;
  height: auto;
  max-height: 45px;
  object-fit: contain;
}

.print-header-title {
  flex: 1;
  text-align: center;
}

.print-header-title h2 {
  margin: 0;
  font-size: 12px;
  font-weight: 900;
  color: #000;
}

@media print {
  .print-header {
    display: flex !important;
  }

  .print-logo {
    width: 55px !important;
    height: auto !important;
    max-height: 45px !important;
  }
}

</style>

        </head>
        <body>
          <div class="page-break">
            <div style="display: flex; justify-content: flex-end;">
      
            </div>
            <div class="print-header">
                <img
                  src="${logo}"
                  class="print-logo"
                  alt="Logo"
                />

                <div class="print-header-title">
                  <h2>فاتورة رقم: ${invoice.invoiceCode || "N/A"}</h2>
                </div>
              </div>
            
            <div class="row">
              <div class="client-info">
                <p><strong>اسم العميل:</strong> ${invoice.customer || "N/A"}</p>
                <p><strong>العنوان:</strong> ${invoice.address || "N/A"}</p>
                <p><strong>الهاتف الاول:</strong> ${invoice.phone || "N/A"}</p>
                <p><strong>الهاتف الثاني:</strong> ${invoice?.socendPhone || "N/A"}</p>
                <p><strong>المحافظة:</strong> ${
                  invoice.governorate?.name || "N/A"
                }</p>
                                <p><strong>الملاحظات:</strong> ${
                                  invoice.note || "N/A"
                                }</p>

              </div>
              <div class="client-info">
                <p><strong>تاريخ الفاتورة:</strong> ${formattedDate}</p>
                <p><strong>السكرتير:</strong> ${invoice.userName || "N/A"}</p>
                <p><strong>المندوب:</strong> ${
                  invoice.representative?.fullName || "N/A"
                }</p>
                        <p><strong>الصفحه:</strong> ${
                          invoice?.page || "N/A"
                        }</p>
              </div>
            </div>
  
            <table>
              <thead>
                <tr>
                  <th>الصنف</th>
                  <th>الكمية</th>
                  <th>السعر</th>
                  <th>الإجمالي</th>
                </tr>
              </thead>
              <tbody>
                ${categoryRows}
              </tbody>
            </table>
  
            <table class="summary-table">
              <tbody>
                <tr>
                  <td><strong>الاجمالي</strong></td>
                  <td>${invoice.totalPrice - invoice.shipping || 0}</td>
                </tr>
                <tr>
                  <td><strong>الشحن</strong></td>
                  <td>${invoice.shipping || 0}</td>
                </tr>
                <tr>
                  <td><strong>الاجمالي مع الشحن</strong></td>
                  <td>${invoice.totalPrice || 0}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </body>
      </html>
    `);

      printWindow.document.close();
      printWindow.print();
    },
    [logo]
  );

  return { handlePrintInvoice };
};

export default usePrintInvoice;
